<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header" v-if="compMode != CRUDMODE.READ">
          {{ $t('project.company.form.finances.title') }}

          <div class="float-right">
            <a href="#FinancialInfo" name="FinancialInfo" @click="addFinancialInfo"><span class="fa fa-plus fa-lg"></span></a>
          </div>
        </div>
        <div class="card-body">
          <div class="row" v-if="showFixedData">

            <div class="form-group col-md-3">
              <label for="capPreInput">{{ $t('project.company.form.finances.preInvestiment') }}</label>
              <input v-model.trim="entite.preInvestiment" v-money="{}" name="capPre" type="text"
               class="form-control" id="capPreInput"  />
              <span class="text-danger" v-if="errors.has('preInvestiment')">{{ errors.first('preInvestiment') }}</span>
            </div>

            <div class="form-group col-md-3">
              <label for="revenuPreInput">{{ $t('project.company.form.finances.incomeBeforeInvestissement') }}</label>
              <input v-model.trim="entite.incomeBeforeInvestissement" v-money="{}" name="revenuPre" type="text" class="form-control" id="revenuPreInput"
                v-bind:placeholder="$t('project.company.form.finances.incomeBeforeInvestissement')"  />
              <span class="text-danger" v-if="errors.has('incomeBeforeInvestissement')">{{ errors.first('incomeBeforeInvestissement') }}</span>
            </div>

          </div>

          <div v-if="!emptyFinancialInformation">
            <div class="row">
              <div class="form-group col-md-3">
                <label for="valeurComparableInput">{{ $t('project.company.form.finances.creation') }}</label>
              
                <moment-date-picker v-model="financialInformation.creation" :required="true"></moment-date-picker>
                <span class="text-danger" v-if="errors.has('creation')">{{ $t('project.company.form.finances.creation') }}</span>
              </div>

              <div class="form-group col-md-3">
                <label for="valeurComparableInput">{{ $t('project.company.form.finances.comparableValue') }}</label>
                <input v-model.trim="financialInformation.comparableValue" name="comparableValue" type="text" class="form-control" id="valeurComparableInput"
                  v-bind:placeholder="$t('project.company.form.finances.comparableValue')"  />
                <span class="text-danger" v-if="errors.has('comparableValue')">{{ errors.first('comparableValue') }}</span>
              </div>
          
              
              <div class="form-group col-md-3">
                <label for="endFinanceYearInput">{{ $t('project.company.form.finances.endFinanceYear') }}</label>
                <input v-model.trim="financialInformation.endFinanceYear" name="endFinanceYear" type="text" class="form-control" id="endFinanceYearInput"
                  placeholder="99/99" v-mask="'##/##'"  />
                <span class="text-danger" v-if="errors.has('endFinanceYear')">{{ errors.first('endFinanceYear') }}</span>
              </div>
            
              
              <div class="form-group col-md-3">
                <label for="turnoverInput">{{ $t('project.company.form.finances.turnover') }}</label>
                <input v-model.trim="financialInformation.turnover" name="turnover" type="number" class="form-control" id="turnoverInput" 
                  v-bind:placeholder="$t('project.company.form.finances.turnover')"  />
                <span class="text-danger" v-if="errors.has('turnover')">{{ errors.first('turnover') }}</span>
              </div>

            </div>
            <div class="row">

              <div class="form-group col-md-3">
                <label for="netProfitInput">{{ $t('project.company.form.finances.netProfit') }}</label>
                <input v-model.trim="financialInformation.netProfit" name="netProfit"
                  type="text" v-money="{}" class="form-control" v-bind:placeholder="$t('project.company.form.finances.netProfit')" />
              </div>
            
              <div class="form-group col-md-3">
                <label for="baiiaEbitdaInput">{{ $t('project.company.form.finances.baiiaEbitda') }}</label>
                <input v-model.trim="financialInformation.baiiaEbitda" v-money="{}" name="baiiaEbitda" type="text" class="form-control" id="baiiaEbitdaInput"
                  v-bind:placeholder="$t('project.company.form.finances.baiiaEbitda')"  />
                <span class="text-danger" v-if="errors.has('baiiaEbitda')">{{ errors.first('baiiaEbitda') }}</span>
              </div>
            
              <div class="form-group col-md-3">
                <label for="exportationIncomePercentageInput">{{ $t('project.company.form.finances.exportationIncomePercentage') }}</label>
                <input v-model.trim="financialInformation.exportationIncomePercentage" v-validate="{ rules: { max_value:100, min_value:0 } }" min=0 max=100
                  name="exportationIncomePercentage" type="number" class="form-control" id="exportationIncomePercentageInput"
                  v-bind:placeholder="$t('project.company.form.finances.exportationIncomePercentage')"  />
                <span class="text-danger" v-if="errors.has('exportationIncomePercentage')">{{ errors.first('exportationIncomePercentage') }}</span>
              </div>
            
              <div class="form-group col-md-3">
                <label for="quebecIncomePercentageInput">{{ $t('project.company.form.finances.quebecIncomePercentage') }}</label>
                <input v-model.trim="financialInformation.quebecIncomePercentage" v-validate="{ rules: { max_value:100, min_value:0 } }" 
                  name="quebecIncomePercentage" 
                  type="number" class="form-control" id="quebecIncomePercentageInput" v-bind:placeholder="$t('project.company.form.finances.quebecIncomePercentage')" />
                <span class="text-danger" v-if="errors.has('quebecIncomePercentage')">{{ errors.first('quebecIncomePercentage') }}</span>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-3">
                <label for="employeeCountFullTimeInput">{{ $t('project.company.form.finances.employeeCountFullTime') }}</label>
                <input v-model.trim="financialInformation.employeeCountFullTime" v-validate="'numeric'" 
                  name="employeeCountFullTime" type="number" class="form-control" id="employeeCountFullTimeInput"
                  v-bind:placeholder="$t('project.company.form.finances.employeeCountFullTime')"  />
                <span class="text-danger" v-if="errors.has('employeeCountFullTime')">{{ errors.first('employeeCountFullTime') }}</span>
              </div>
              
              <div class="form-group col-md-3">
                <label for="employeeCountFullPartInput">{{ $t('project.company.form.finances.employeeCountFullPart') }}</label>
                <input v-model.trim="financialInformation.employeeCountFullPart" v-validate="'numeric'" name="employeeCountFullPart"
                  type="number" class="form-control" id="employeeCountFullPartInput"  v-bind:placeholder="$t('project.company.form.finances.employeeCountFullPart')" />
                <span class="text-danger" v-if="errors.has('employeeCountFullPart')">{{ errors.first('employeeCountFullPart') }}</span>
              </div>

              <div class="form-group col-md-3">
                <label for="employeeCountOthersInput">{{ $t('project.company.form.finances.employeeCountOthers') }}</label>
                <input v-model.trim="financialInformation.employeeCountOthers" v-validate="'numeric'" name="employeeCountOthers" 
                  type="number" class="form-control" id="employeeCountOthersInput"  v-bind:placeholder="$t('project.company.form.finances.employeeCountOthers')" />
                <span class="text-danger" v-if="errors.has('employeeCountOthers')">{{ errors.first('employeeCountOthers') }}</span>
              </div>

              <div class="form-group col-md-3">
                <label for="employeeCountTotal">{{ $t('project.company.form.finances.employeeCountTotal') }}</label>
                <input disabled="true" v-model.trim="employeeCountTotal" v-validate="'numeric'" name="employeeCountTotal" readonly
                  type="number" class="form-control" v-bind:placeholder="$t('project.company.form.finances.employeeCountTotal')" />
              </div>
            </div>
          </div>
          <div v-else style="border-top: 1px solid rgba(0,0,0,.225); padding: 15px 0px;">
            {{ $t("project.company.form.finances.no_data")}}
          </div>
        </div>
      </div>
    </div>
  </div>
    
</template>

<script>
  import {CompanyServiceClient, FinancialInformationDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'

  export default {
    name: 'CreateFinancialInformation',
    props: {
      financialInformation: {
        type: FinancialInformationDto,
      },
      emptyFinancialInformation: {
        type: Boolean,
        default: true,
      },
      entite: {},
      showFixedData: {
        type: Boolean,
        default: true,
      },
    },
    mixins: [CrudMixin],
    mounted: function() {
      this.fetchData()
      this.setMode()
    },
    computed: {
      employeeCountTotal: function() {
        if (this.financialInformation != null) {
          return (
            (parseInt(this.financialInformation.employeeCountFullTime) || 0) +
            (parseInt(this.financialInformation.employeeCountFullPart) || 0) +
            (parseInt(this.financialInformation.employeeCountOthers) || 0)
          )
        } else {
          return 0
        }
      },
    },
    methods: {
      addFinancialInfo: function() {
        if (!this.emptyFinancialInformation) {
          let old = Object.assign({}, this.financialInformation)
          old.status = false
          old.historique = moment()

          let oldDto = new FinancialInformationDto()
          oldDto.init(old)
  
          this.$emit('addClick', oldDto)
          this.financialInformation.creation = moment()
          this.financialInformation.id = undefined
        } else {
          this.$emit('addClick', null)
        }
      },
      fetchData: function() {},
    },
    components: {
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/projects/CreateFinancialInfo.vue